import { Dispatch } from 'react';
import ReactJson from 'react-json-view';
import { useBoolean } from 'ahooks';
import { Divider, Modal, Spin } from 'antd';

import { useGetRequest } from 'hooks';

import { TransactionRaw } from 'codegen';

export const RawModal = ({
  requestData,
  setRequestData,
}: {
  requestData?: { snapId: number; transactionId: number};
  setRequestData: Dispatch<undefined>
}) => {
  const [isOpen, { setTrue, setFalse }] = useBoolean();

  const { data, loading } = useGetRequest<TransactionRaw>({
    url: `/snaps/${requestData?.snapId}/transactions/${requestData?.transactionId}/raw`,
    options: {
      ready: !!requestData,
      refreshDeps: [requestData],
      onSuccess: setTrue,
    },
  });

  const request = data?.request ? data.request : {};
  const response = data?.successResponse ? data.successResponse : data?.errorResponse;

  return (
    <Modal
      width={700}
      title='Raw Transactions'
      open={isOpen}
      onOk={setFalse}
      onCancel={setFalse}
      afterClose={() => setRequestData(undefined)}
      cancelButtonProps={{ className: 'hidden' }}
    >
      <Spin spinning={loading}>
        <strong>Request Json</strong>

        <ReactJson src={request} />

        <Divider />

        <strong>Response Json</strong>

        <ReactJson src={response || {}} />
      </Spin>
    </Modal>
  );
};
